import { showPopup } from "./popupHook";
let resultListKey = () => `resultList_${window["id"]}_${window["accountName"]}`;
let questionListKey = () =>
  `questionList_${window["id"]}_${window["accountName"]}`;
let surveyEditTimeKey = () => `survey_edit_latest_${window["id"]}`;
let answerStartTimeKey = () => `answer_start_time_${window["id"]}`;
export const clearLocalData = () => {
  localStorage.removeItem(surveyEditTimeKey());
  localStorage.removeItem(resultListKey());
  localStorage.removeItem(questionListKey());
};
// 缓存作答结果
export const saveResultList = (resultList) => {
  if (window["isPreview"]) {
    return;
  }
  localStorage.setItem(resultListKey(), JSON.stringify(resultList));
};

// 缓存问卷最新编辑时间
export const saveSurveyEditTime = (time) => {
  if (window["isPreview"]) {
    return;
  }
  localStorage.setItem(surveyEditTimeKey(), time);
};

// 缓存问卷作答时间，打点用到
export const saveAnswerStartTime = (time) => {
  if (window["isPreview"]) {
    return;
  }
  localStorage.setItem(answerStartTimeKey(), time);
};

// 缓存问卷（选项随机后）题目列表，同一用户重新访问问卷时不再随机
export const saveQuestionList = (questionList) => {
  if (window["isPreview"]) {
    return;
  }
  // 存在历史questionList则不更新缓存，否则会重新打乱选项顺序
  !localStorage.getItem(questionListKey()) &&
    localStorage.setItem(questionListKey(), JSON.stringify(questionList));
};

export const loadResultList = () => {
  return localStorage.getItem(resultListKey());
};
export const loadQuestionList = () => {
  return localStorage.getItem(questionListKey());
};
export const loadSurveyEditTime = () => {
  return localStorage.getItem(surveyEditTimeKey());
};
export const loadAnswerStartTime = () => {
  return localStorage.getItem(answerStartTimeKey());
};

// 检查是否有历史记录
export const checkHasHistory = (time) => {
  if (window["isPreview"]) {
    return;
  }
  if (!time) {
    return;
  }
  let localSurveyEditTime = loadSurveyEditTime();
  // 问卷已编辑过，则不提示读取历史记录弹窗
  if (time !== localSurveyEditTime) {
    // 清除相关记录
    clearLocalData();
    return;
  }

  let localResultList = loadResultList();
  localResultList && JSON.parse(localResultList).length && showPopup("history");
};
